const urlPatterns = {
    [1]: username => `https://x.com/${username}`,
    [2]: username => `https://www.instagram.com/${username}/`,
    [3]: username => `https://www.facebook.com/${username}/`,
    [23]: username => `https://www.tiktok.com/@${username}`,
};
const buildAccountUrl = ({ platformId, username }) => {
    if (urlPatterns[platformId]) return urlPatterns[platformId](username);
    return '';
};

export default buildAccountUrl;
